import { FORMFIELDS } from 'pages/PushNotification/form';
import { PushNotificationModuleFormValues } from 'pages/PushNotification/form';
import { UserMessageTemplate } from 'store/actionCreators/currentCommunity';

import { axiosInstance as axios } from './index';

const sendPushNotification = async ({
  communityId,
  data,
  userId,
  withImage,
  eventId,
  chats,
}: {
  communityId: string;
  data: PushNotificationModuleFormValues;
  userId: string;
  withImage: boolean;
  eventId?: string;
  chats?: boolean;
}) => {
  const formData = {
    userId,
    communityId,
    withImage,
    eventId,
    [FORMFIELDS.RECIPIENTS]: data[FORMFIELDS.RECIPIENTS],
    [FORMFIELDS.TITLE]: data[FORMFIELDS.TITLE],
    [FORMFIELDS.MESSAGE]: data[FORMFIELDS.MESSAGE],
    [FORMFIELDS.SENDCOPY]: data[FORMFIELDS.SENDCOPY],
    [FORMFIELDS.REDIRECT_LINK]: data[FORMFIELDS.REDIRECT_LINK] ?? '',
  };

  const response = await axios.post(
    `/pushNotification?chats=${!!chats}`,
    formData,
  );
  return response.data;
};

const getTemplates = async ({ communityId, userId }) => {
  const response = await axios.get(`/getTemplate/${userId}/${communityId}`);
  return response.data;
};

const saveTemplate = async ({
  userId,
  message,
  title,
  communityId,
}: {
  userId: string;
  title: string;
  message: string;
  communityId: string;
}) => {
  const data = { userId, message, title, communityId };
  const response = await axios.post('/postTemplate', data);
  return response.data;
};

const saveDefaultTemplates = async ({
  defaultTemp,
}: {
  defaultTemp: UserMessageTemplate;
}) => {
  const response = await axios.post('/postDefaultTemplate', defaultTemp);
  return response.data;
};

const deleteTemplates = async ({
  id,
  userId,
  communityId,
}: {
  id: string;
  userId: string;
  communityId: string;
}) => {
  const response = await axios.delete(`/deleteTemplate/${id}`);

  return response.data;
};

export {
  deleteTemplates,
  getTemplates,
  saveDefaultTemplates,
  saveTemplate,
  sendPushNotification,
};
